import type { SafeHtmlAttributes } from "../../types/SafeHtmlAttributes";

import styles from "./FormFieldLabel.module.scss";

export type FormFieldLabelVariantProps =
  | {
      necessityIndicator?: true;
      asterisk?: never;
    }
  | {
      necessityIndicator?: never;
      asterisk?: true;
    };

export type FormFieldLabelProps = {
  label: string;
  required?: boolean;
  htmlFor?: string;
  requiredText?: string;
  optionalText?: string;
} & FormFieldLabelVariantProps &
  SafeHtmlAttributes<HTMLLabelElement>;

export const FormFieldLabel = ({
  label,
  necessityIndicator,
  asterisk,
  required,
  requiredText,
  optionalText,
  htmlFor,
  ...rest
}: FormFieldLabelProps) => {
  const showAsterisk = Boolean(asterisk && required && !necessityIndicator);
  const showNecessityIndicator = Boolean(necessityIndicator && !asterisk);

  return (
    <label className={styles.root} htmlFor={htmlFor} {...rest}>
      <span className={styles.label}>{label}</span>
      {showAsterisk && (
        <span aria-hidden="true" className={styles.indicator}>
          *
        </span>
      )}
      {showNecessityIndicator && <span className={styles.indicator}>{required ? requiredText : optionalText}</span>}
    </label>
  );
};
